exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-pie.js
// module id = 54
// module chunks = 0